<template>
  <div>
   <transition name="fade">
    <div id="SaveWaitingMessage" v-if="this.$store.state.waiting" class="z-depth-5">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </transition>
  </div>
</template>

<script>
export default {
  name: 'Waiting',
};
</script>

<style lang="scss">
@import "../../static/MDB-PRO/sass/mdb/free/data/colors";

#SaveWaitingMessage {
  color: $success-color;
  font-size: 72px;
  position: fixed;
  background: white;
  border-radius: 100%;
  border: 15px solid $rgba-green-strong;
  width: 200px;
  height: 200px;
  z-index: 100;
  text-align: center;
  line-height: 175px;
  left: 50%;
  margin-left: -100px;
  top: 50%;
  margin-top: -100px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s, transform .8s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
  transform: translateY(200px);

}
</style>



// WEBPACK FOOTER //
// Waiting.vue?29ab1738